import { State } from "@progress/kendo-data-query";
import { GridColumnMenuFilter } from "@progress/kendo-react-grid";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons/faFilter";
import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { Dispatch, ReactElement, SetStateAction } from "react";

export const isColumnFilterActive = (field: string | undefined, dataState: State) => {
  return field === undefined ? false : GridColumnMenuFilter.active(field, dataState.filter);
};

export const showActiveFilters = (showTooltip: boolean, tooltipText: string) => {
  if (showTooltip) {
    return (
      <Tooltip title={`Aktive Filter: ${tooltipText}`}>
        <FontAwesomeIcon icon={faFilter} size="sm" />
      </Tooltip>
    );
  }

  return (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={faFilter} size="sm" />
      <FontAwesomeIcon icon={faBan} size="lg" color="red" />
    </span>
  );
};

export const summarizeActiveFilters = (
  currentDatastate: State,
  columns: ReactElement[],
  setTooltipText: Dispatch<SetStateAction<string>>,
  setDisplayFlag: Dispatch<SetStateAction<boolean>>
) => {
  let tooltipText = "";
  // check in column row filters for active filters
  currentDatastate.filter?.filters.forEach((filterDescriptor) => {
    if ("field" in filterDescriptor) {
      const columnTitle = columns.find((column) => column.props.field === filterDescriptor.field)
        ?.props.title;
      tooltipText += `${columnTitle}, `;
    }
  });

  // check in column menu filters for active filters
  columns.forEach((column) => {
    if (isColumnFilterActive(column.props.field, currentDatastate)) {
      tooltipText += `${column.props.title}, `;
    }
  });
  tooltipText = tooltipText.slice(0, -2);
  setTooltipText(tooltipText);
  setDisplayFlag(tooltipText.length > 0);
};
